var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8032_3084)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8032_3084",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8032_3084)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8032_3084",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8032_3084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H8C3.58172 0 0 3.58172 0 8V40C0 44.4183 3.58172 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58172 44.4183 0 40 0Z",
    fill: "url(#paint0_linear_8032_3084)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.796 33H26.544C26.0362 32.9527 25.5575 32.7549 25.1777 32.4351C24.7979 32.1152 24.5366 31.6902 24.432 31.2217L21.216 17.2425L17.904 24.4459C17.8103 24.6473 17.6558 24.8185 17.4596 24.9385C17.2636 25.0585 17.0342 25.122 16.8 25.1213H13.2C12.8818 25.1213 12.5765 25.0027 12.3515 24.7916C12.1265 24.5805 12 24.2942 12 23.9957C12 23.6972 12.1265 23.4109 12.3515 23.1999C12.5765 22.9888 12.8818 22.8702 13.2 22.8702H16.008L19.02 16.3533C19.2228 15.9161 19.5684 15.5504 20.0069 15.3092C20.4455 15.068 20.9544 14.9636 21.4603 15.0112C21.9662 15.0587 22.4429 15.2558 22.8217 15.5739C23.2006 15.892 23.4618 16.3147 23.568 16.781L26.784 30.7489L30.096 23.568C30.186 23.3625 30.3389 23.1866 30.5353 23.0623C30.7319 22.9382 30.9631 22.8713 31.2 22.8702H34.8C35.1182 22.8702 35.4235 22.9888 35.6485 23.1999C35.8735 23.4109 36 23.6972 36 23.9957C36 24.2942 35.8735 24.5805 35.6485 24.7916C35.4235 25.0027 35.1182 25.1213 34.8 25.1213H31.992L28.98 31.6381C28.796 32.0394 28.4917 32.3817 28.1039 32.6236C27.716 32.8654 27.2616 32.9962 26.796 33Z",
    fill: "#CurrentColor"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8032_3084",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8032_3084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/Activity-Icon.0b1fb69dea2e6d0869c542dc0f01ad72.svg";
export { ForwardRef as ReactComponent };